import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { globals } from "../../globals";
import { Observable } from "rxjs";
import { QueryFilterService } from "./query-filter-service";
import { IGridifyQuery } from "gridify-client";
import { PaginatedModel } from "../../dominio/paginated-model";
import { AnaliseCreditoIntegradorModel } from "../../dominio/analise-credito-integrador-model";

export class DetalharAnaliseCreditoIntegradorResponse {
  result: AnaliseCreditoIntegradorModel;
}

export class ListarAnaliseCreditoIntegradorResponse {
  results: AnaliseCreditoIntegradorModel[];
  pagination: PaginatedModel;
}

export class CadastrarAnaliseCreditoIntegradorRequest {
  idAnaliseCredito: number;
  situacao: number;
}

export class AlterarAnaliseCreditoIntegradorRequest {
  situacao: number;
}

@Injectable({
  providedIn: "root",
})
export class AnaliseCreditoIntegradorService {
  constructor(private http: HttpClient, private queryFilterService: QueryFilterService) {}

  listar(
    idIntegrador: number,
    queryFilter: IGridifyQuery | null = null
  ): Observable<ListarAnaliseCreditoIntegradorResponse> {
    const params = this.queryFilterService.getQueryParams(queryFilter);

    return this.http.get<ListarAnaliseCreditoIntegradorResponse>(
      `${globals.apiUrl}/api/v2/core/integrador/${idIntegrador}/analise-credito`,
      { params }
    );
  }

  cadastrar(
    idIntegrador: number,
    data: CadastrarAnaliseCreditoIntegradorRequest
  ): Observable<DetalharAnaliseCreditoIntegradorResponse> {
    return this.http.post<DetalharAnaliseCreditoIntegradorResponse>(
      `${globals.apiUrl}/api/v2/core/integrador/${idIntegrador}/analise-credito`,
      data
    );
  }

  alterar(
    idIntegrador: number,
    idAnalise: number,
    data: AlterarAnaliseCreditoIntegradorRequest
  ): Observable<DetalharAnaliseCreditoIntegradorResponse> {
    return this.http.put<DetalharAnaliseCreditoIntegradorResponse>(
      `${globals.apiUrl}/api/v2/core/integrador/${idIntegrador}/analise-credito/${idAnalise}`,
      data
    );
  }

}
